import * as yup from "yup";
import { Max, Min, Validation } from "../../utils/Validation.utils";
export const InsuranceInitialValues = {
    name: ""
};
export const InsuranceSchema = yup.object().shape({
    name: yup
        .string()
        .min(Min.Name, Validation.Min)
        .max(Max.Name, Validation.Max)
        .required(Validation.Required)
});
